// extracted by mini-css-extract-plugin
export default {"teaser-wrapper":"sOWN4","teaser-wrapper--with_height":"DG1XR"};